import {
  arrayOf,
  number,
  shape,
  string,
} from 'prop-types';

import { branch } from 'types/branch';

import eligibleFriend from './eligibleFriend';

export default shape({
  actMessagePreview: string.isRequired,
  branchId: number.isRequired,
  branch: branch.isRequired,
  eligibleFriends: arrayOf(eligibleFriend).isRequired,
});
